<div class="">
    <div class="bg-white">
        <div class="row align-items-end pb-3 h-120">
            <div class="col-1"></div>
            <div class="col-7">
                <span class="header-content">
                    Admin Profile
                </span>
            </div>
        </div>
    </div>
    <div class="bg-grey" style="height: 100vh;">
        <div class="row pt-5">
            <div class="col-1"></div>
            <div class="col-7">
                <div class="card border-0 shadow-sm">
                    <div class="h-70 d-flex align-items-center justify-content-between px-4">
                        <div class="font-20">{{profileData.first_name}} {{profileData.last_name}}</div>
                        <div class="admin-badge">
                            <div>
                                Admin
                            </div>
                        </div>
                    </div>
                    <hr class="m-0 border">
                    <div class="row align-items-center h-70 px-4">
                        <div class="col-8">
                            <div class="label sub-content cursor">Email</div>
                            <div class="">{{profileData.email}}</div>
                        </div>
                        <div class="col-4">
                            <div class="primary-btn-txt cursor" (click)="navToPage('email')"> Change Email</div>
                        </div>
                    </div>
                    <hr class="m-0">
                    <div class="row align-items-center h-70 px-4">
                        <div class="col-8">
                            <div class="label sub-content cursor">Password</div>
                            <div class="">*************</div>
                        </div>
                        <div class="col-4">
                            <div class="primary-btn-txt cursor" (click)="navToPage('password')"> Change Password</div>
                        </div>
                    </div>
                    <hr class="m-0">
                    <div class="row align-items-center h-70 px-4">
                        <div class="col-8">
                            <div class="label sub-content cursor">Help and Support</div>
                            <div class="">{{profileData.help_and_support.phone_number}}</div>
                        </div>
                        <div class="col-4">
                            <div class="primary-btn-txt cursor" (click)="navToPage('phone_number')"> Change Phone Number</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>